import TagCategoryManagementComponent from 'components/desktop/StandingData/TagCategory/Management/TagCategoryManagementComponent';

const TagCategoryManagementContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<TagCategoryManagementComponent />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default TagCategoryManagementContainer;
